/* istanbul ignore file */
import React from 'react';
import RelatedCompanyRolesList from './RelatedCompanyRolesList';

const CompanyRolesList = () => <RelatedCompanyRolesList />;

export default CompanyRolesList;
